import { ofType } from 'redux-observable';
import { switchMap, map, mapTo } from 'rxjs/operators';
import * as moment from 'moment';
import { Type } from './redux';
// todo  修改这里的引入方式
// import scaleImage from '../../../../core/utils/imageUtil';

const getList = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_LIST),
    switchMap(({ exerciseId, scope, pageIndex, pageSize = 20 }) =>
      fetch({
        url: `/mm-tiku/api/v1/paper/${exerciseId}/aggreScore/list`,
        method: 'GET',
        scope,
        body: {
          exerciseId,
          pageIndex,
          pageSize,
        },
      }),
    ),
    map(({ list = [], query = {} }) => ({
      type: Type.GET_LIST_SUCCESS,
      list: list
        ? list.map(item => {
            // 裁剪用户头像
            const avator =
              item.largeFaceUrl ||
              'https://edu-image.nosdn.127.net/49E89BEA3F1B3F1AC788F5F94C4A457F.png';
            return {
              ...item,
              // 格式化提交时间
              submitTimeFormat: item.submitTime
                ? moment(item.submitTime).format('YYYY/MM/DD HH:mm')
                : '--',
              avator,
            };
          })
        : [],
      total: query.totleCount || 0,
      query,
    })),
  );

const exerciseStatisticsNext = action$ =>
  action$.pipe(
    ofType(Type.EXERCISE_NEXT),
    mapTo({ type: Type.GET_LIST }),
  );

export default [getList, exerciseStatisticsNext];
